



























import Vue from 'vue';
import {Component} from 'vue-property-decorator';
import Icon from '@/components/Icon.vue';
import tagListDB from '@/dataBase/tagListDB';
import defaultPayTag from '@/constants/defaultPayTag';
import defaultIncomeTag from '@/constants/defaultIncomeTag';

@Component({
  components: {Icon}
})
export default class TagAdd extends Vue {
  type!: string;
  // TODO
  // 这两个默认值有点问题？
  tagId = 0;
  iconName = '';
  text = '';
  totalTagList: myTag[] = [];

  getCurrentTagList(type: string) {
    if (type === '-') {
      this.totalTagList = tagListDB.filter(item => item.type === '-');
      this.iconName = defaultPayTag.iconName;
      this.tagId = defaultPayTag.id;
    } else if (type === '+') {
      this.totalTagList = tagListDB.filter(item => item.type === '+');
      this.iconName = defaultIncomeTag.iconName;
      this.tagId = defaultIncomeTag.id;
    }
    return;
  }

  selectedIcon(tag: myTag) {
    this.tagId = tag.id;
    this.iconName = tag.iconName;
  }

  created() {
    this.$store.commit('initTag');
    this.type = this.$route.params.managetype;
    this.getCurrentTagList(this.type);
  }

  createOneTag() {
    const {type, iconName, text} = this;
    const tag: myTag = {id: this.tagId, type, iconName, text};
    if (tag) {
      try {
        this.$store.commit('createTag', tag);
        this.$router.back();
      } catch (error) {
        if (error.message === 'icon duplicated') {
          window.alert('标签图标重复，请重新选择图标！');
        } else if (error.message === 'text duplicated') {
          window.alert('标签名称重复，请重新输入名称！');
        } else {
          this.$router.back();
        }
      }
    }
  }
}
